export function formatSessionRole(role) {
  if (!role) return "";
  return role === "Owner" ? "Admin" : role;
}
